import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { TableTextCell } from 'shared_DEPRECATED/components/Table';

import {
  CurrentWeekCell,
  ParticipantsTableCoachingModeCell,
  ParticipantsTableMomentumCell,
  ParticipantsTableSprintDurationCell,
  ParticipantsTableUserInfoCell,
  SessionDateCell,
} from 'features/participants/components/Table/';
import { ParticipantsTableActionsCell } from 'features/participants/components/Table/ActionsCell';
import {
  sortTableByMomentumScore,
  sortTableBySessionDate,
  sortTableBySprintStartDate,
  sortTableByUnreadJournalRecordDateTime,
  sortTableByUserName,
} from 'features/participants/utils';

import { JournalsCell } from '../components/Table/Actions/JournalsCell';

export const columnsData = [
  {
    header: 'Name',
    accessorKey: 'userInfo',
    cell: ParticipantsTableUserInfoCell,
    sortingFn: sortTableByUserName,
  },
  {
    header: 'Sprint number',
    accessorKey: 'coachedSprintsCount',
    cell: ({ getValue }) => (
      <TableTextCell dataTestId="participant-sprint-number">
        {getValue()}
      </TableTextCell>
    ),
    sortUndefined: 'last',
  },
  {
    header: 'Sprint dates',
    accessorKey: 'sprintDuration',
    sortingFn: sortTableBySprintStartDate,
    cell: ParticipantsTableSprintDurationCell,
    sortUndefined: 'last',
  },
  {
    header: 'Sprint week',
    accessorKey: 'currentWeekNumber',
    cell: CurrentWeekCell,
    sortUndefined: 'last',
  },
  {
    header: 'Frequency',
    accessorKey: 'coachingMode',
    cell: ParticipantsTableCoachingModeCell,
  },
  {
    header: 'Next session',
    accessorKey: 'nextSessionAppointment',
    cell: SessionDateCell,
    sortingFn: sortTableBySessionDate,
    sortUndefined: 'last',
  },
  {
    header: 'Momentum',
    accessorKey: 'momentumScores',
    cell: ParticipantsTableMomentumCell,
    sortingFn: sortTableByMomentumScore,
    sortUndefined: 'last',
  },
  {
    header: 'Actions',
    enableSorting: false,
    cell: ParticipantsTableActionsCell,
  },
  {
    header: (
      <Icon
        name={iconNames.message}
        width="14px"
        height="14px"
        stroke="var(--fgSecondary)"
      />
    ),
    accessorKey: 'journal',
    cell: JournalsCell,
    sortingFn: sortTableByUnreadJournalRecordDateTime,
  },
];
